import messages from './messages.tsx';

export const redactionsLabel = messages.redactions;
